import { useDispatch, useSelector } from "react-redux";
import { doneWithLocations } from "../../../redux/ui/ui";
import {
  getKeyFrameCount,
  getRequestedAlgorithm,
} from "../../../redux/selectors";
import { Button, Tooltip } from "antd";
import CheckMark from "remixicon-react/CheckLineIcon";
import { iconSize } from "../../../config";
import { algorithms } from "../../../util/constants";

export const DoneButton = () => {
  const dispatch = useDispatch();
  const done = () => {
    dispatch(doneWithLocations());
  };
  const kfCount = useSelector(getKeyFrameCount);
  const requestedAlgorithm = useSelector(getRequestedAlgorithm);
  const disabled =
    requestedAlgorithm === algorithms.manual ? kfCount < 1 : kfCount < 3;
  const tooltipContent = !disabled
    ? "Finish placing"
    : requestedAlgorithm === algorithms.spin
    ? `Place hotspot on ${3 - kfCount} more frames `
    : "Manually place hotspot on one or more frames";

  return (
    <Tooltip title={tooltipContent}>
      <Button
        type="primary"
        onClick={done}
        disabled={disabled}
        icon={<CheckMark size={iconSize} />}
      >
        Done
      </Button>
    </Tooltip>
  );
};
